<template>
  <div>
    <el-drawer title="查看员工" :visible.sync="drawer" direction="rtl" size="75.7%" append-to-body custom-class="drawer my-drawer">
      <div style="padding-left: 24px;">
        <el-tabs v-model="activeName" class="custom-tabs2" @tab-click="toggleTab">
          <el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in tags" :key="index"></el-tab-pane>
        </el-tabs>
      </div>

      <div v-if="activeName == 1" class="main">
        <emplpyment-detail  :detail="detail"/>
        <div class="back">
          <div class="back-btn" @click="drawer = false">返回</div>
        </div>
      </div>
      <div v-if="activeName == 2" class="main">
        <div class="title">角色权限</div>
        <div class="main-content">
          <el-form :inline="true" class="form" size="small" label-width="82px" label-position="right">
            <el-form-item label="钉钉角色：" style="margin-right:197px">
              <div v-if="detail.autoRoleName && detail.autoRoleName.length > 0" style="display:flex;">
                <div v-for="(item, index) in detail.autoRoleName">
                  {{ item }}<span v-if="index != detail.autoRoleName.length - 1">,</span>
                </div>
              </div>

              <div v-else>--</div>
            </el-form-item>
            <el-form-item label="OA角色">
              <el-select v-model="detail.roleIds" v-show="roleDataList.length>0" placeholder="" multiple disabled>
                <el-option v-for="item in roleDataList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
              <!-- <el-select v-model="detail.roleName" placeholder="请选择" disabled>

                          </el-select> -->
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import EmplpymentDetail from './EmplpymentDetail.vue'

export default {
  name: 'viewEmployment',
  components: {
    EmplpymentDetail,
  },
  data() {
    return {
      drawer: false,
      tags: [
        {
          label: '员工信息',
          name: '1'
        },
        {
          label: '角色权限',
          name: '2'
        }
      ],
      activeName: '1',
      detail:{},
      roleDataList: [],
    }
  },
  methods: {
    show(id) {
      this.drawer = true
      this.detail = {}
      this.getDetail(id)
    },
    getDetail(id) {
        this.axios.get('/oa/sys/employee/' + id).then((res) => {
            console.log(res)
            if (res.code == 0) {
                this.detail = res.data
                if (this.detail.updatedTime && this.detail.updatedTime.includes(' ')) {
                    this.detail.updatedTimeFormat = this.detail.updatedTime.split(' ')[0]
                }
            } else {
                this.$message.error(res.message)
            }
        })
    },
    toggleTab(){
      if (this.activeName==2 && this.roleDataList.length == 0) {
        this.getRoleList()
      }
    },
    // 角色下拉列表数据
      getRoleList() {
          const data = {
              pageNo: 1,
              pageSize: 10000
          }
          this.$api.rolePageList(data).then(res => {
              console.log(res)
              if (res.code == 0) {
                  this.roleDataList = res.data.list
              } else {
                  this.$message.error(res.message);
              }
          })
      },
  },
}
</script>
<style lang='scss' scoped>
.main {
    position: relative;
    // padding-top: 24px;
    // height: 100%;
    box-sizing: border-box;
    padding-left: 24px;
    // padding-right: 24px;
   .title {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 16px;
        color: #2F3030;
        margin-top: 32px;
    }
      .main-content {
        margin-top: 30px;

    }

    .back {
        // width: 1436px;
        height: 64px;
        background: #FFFFFF;
        // background: red;
        border-radius: 0px 0px 0px 8px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        position: absolute;
        left: 0;
        right: 0;
        bottom: -64px;
        border-top: 1px solid #EDF2F2;

        .back-btn {
            width: 88px;
            height: 36px;
            background: #EDF2F2;
            border-radius: 4px 4px 4px 4px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #939696;
            line-height: 36px;
            text-align: center;
            margin-left: 24px;
            cursor: pointer;

        }
    }
}
.drawer{
    min-width: 1088px;
}
   
</style>